import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { Button, Input, Select, DatePicker } from "antd";
import { CustomLabel } from "../../../utilities/utll";
import { FilterOutlined } from "@ant-design/icons";
import { useIrnStore } from "../../../store/useIrnstore";
import { useNearToExpiryScanStore } from "../../../store/useNTEScanStore";

export const FilterMode = () => {
  const { getStore, stores } = useIrnStore();
  const {
    formData,
    formErrors,
    setFormField,
    handleBarcodeScan,
    saveScanData,
    handleCriticalFieldChange,
  } = useNearToExpiryScanStore();

  useEffect(() => {
    getStore();
  }, []);
  const searchBy = ["Barcode", "Item Code"];
  return (
    <>
      <Row>
        <Col xl={3} md={6}>
          <CustomLabel children={"Store"} isImportnt={false} />
          <Select
            id="roletype"
            placeholder="Select "
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            options={stores.map((s) => ({
              value: s.StoreCode,
              label: s.StoreName,
            }))}
            value={formData.StoreCode}
            onChange={(val) => handleCriticalFieldChange("StoreCode", val)}
          />
          {formErrors.StoreCode && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {formErrors.StoreCode}
            </span>
          )}
        </Col>

        <Col xl={2} md={6}>
          <CustomLabel children={" Date"} isImportnt={false} />
          <DatePicker
            format="DD-MMM-YYYY"
            placeholder="Select a date"
            style={{ width: "100%" }}
            value={formData.date}
            onChange={(date) => handleCriticalFieldChange("date", date)}
          />
          {formErrors.date && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {formErrors.date}
            </span>
          )}{" "}
        </Col>
        {/* <Col xl={3} md={6}>
          <CustomLabel children={"Divison"} isImportnt={false} />
          <Select
            id="roletype"
            placeholder="Select "
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            options={
              Array.isArray(category)
                ? category.map((item) => ({
                    label: item.DivisionName,
                    value: item.Division,
                  }))
                : []
            }
            value={formData?.divisionCode}
            onChange={(val, option) => {
              handleInputChange("divisionCode", val);
            }}
          />
          {errors.divisionCode && (
            <span style={{ color: "red", fontSize: 12 }}>
              {errors.divisionCode}
            </span>
          )}
        </Col> */}
        <Col xl={2} md={6}>
          <CustomLabel children={"Search By"} isImportnt={false} />
          <Select
            id="roletype"
            placeholder="Select "
            allowClear
            showSearch
            optionFilterProp="label"
            size="medium"
            style={{ width: "100%" }}
            options={searchBy.map((t) => ({
              value: t,
              label: t,
            }))}
            value={formData.searchBy}
            onChange={(val) => setFormField("searchBy", val)}
          />
          {formErrors.searchBy && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {formErrors.searchBy}
            </span>
          )}
        </Col>
        <Col xl={3} md={6}>
          <CustomLabel
            children={
              formData.searchBy === "Item Code"
                ? "Search Item Code"
                : "Search Bar Code"
            }
            isImportnt={false}
          />
          <Input
            name="vendorname"
            id="vendorname"
            type="text"
            placeholder="Enter Code No"
            size="medium"
            value={formData.searchBarCode}
            onChange={(e) => setFormField("searchBarCode", e.target.value)}
            onBlur={handleBarcodeScan}
          />
        </Col>

        <Col xl={1} style={{ textAlign: "center", marginTop: "1rem" }}>
          <Button
            type="primary"
            icon={<FilterOutlined />}
            size="large"
            style={{
              marginRight: "0.75rem",
              backgroundColor: "#64c41aff", // elegant green
              borderColor: "#69c41aff",
              boxShadow: "0 2px 6px rgba(2, 2, 65, 0.3)",
            }}
            onClick={saveScanData}
          >
            Save
          </Button>
        </Col>
      </Row>
    </>
  );
};
